import { ExperienceId } from '@/console/host/experience.types';
import { CONSOLE_EXPERIENCE_STORAGE_KEY } from '@/shared/utils/storage/storage-keys';

export { CONSOLE_EXPERIENCE_STORAGE_KEY } from '@/shared/utils/storage/storage-keys';

export const DEFAULT_CONSOLE_EXPERIENCE: ExperienceId = 'classic';

export const isExperienceId = (value: unknown): value is ExperienceId =>
  value === 'classic' || value === 'modern';

export const getPreferredExperience = (
  storage: Storage | undefined = globalThis.localStorage,
): ExperienceId => {
  const storedExperience = storage?.getItem(CONSOLE_EXPERIENCE_STORAGE_KEY);

  if (isExperienceId(storedExperience)) {
    return storedExperience;
  }

  return DEFAULT_CONSOLE_EXPERIENCE;
};

export const setPreferredExperience = (
  experience: ExperienceId,
  storage: Storage | undefined = globalThis.localStorage,
) => {
  storage?.setItem(CONSOLE_EXPERIENCE_STORAGE_KEY, experience);
};
